import { Component, OnInit, ViewChild, Input, Output, EventEmitter, SimpleChanges, AfterViewInit, OnChanges } from '@angular/core';
import { MatPaginator, MatSort, MatDialog } from '@angular/material';
import { CustomDataSource } from 'path-shared/services/datasource/custom.datasource';
import { FilterService } from 'path-shared/services/filter/filter.service';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { merge } from 'rxjs';
import { tap } from 'rxjs/operators';
import { DownloadExcelDialogComponent } from 'path-shared/components/dialogs/download-excel-dialog/download-excel-dialog.component';
import { Builder } from 'path-shared/models/builder';
import { SeguretatGrups } from '../../models/seguretat-grups.model';
import { SeguretatGrupsFilter } from '../../models/seguretat-grups-filter';
import { SeguretatGrupsService } from '../../services/seguretat-grups.service';
import { SeguretatGrupsFilterService } from '../../services/seguretat-grups-filter.service';


@Component({
  selector: 'app-seguretat-grups-table',
  templateUrl: './seguretat-grups-table.component.html',
  styleUrls: ['./seguretat-grups-table.component.scss']
})
export class SeguretatGrupsTableComponent implements OnInit, OnChanges, AfterViewInit {

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  data: SeguretatGrupsTableComponent[];
  dataSource: CustomDataSource<SeguretatGrups, SeguretatGrupsFilter>;
  filter: SeguretatGrupsFilter = new SeguretatGrupsFilter('codiGrup', 'asc');
  displayedItems = [];
  highlightedRows = [];

  @Input() selectButton: boolean;
  @Input() updatedFilterData: SeguretatGrupsFilter;
  @Output() notify: EventEmitter<number> = new EventEmitter<number>();
  @Output() itemClicked: EventEmitter<string> = new EventEmitter<string>();
  @Output() itemSelected: EventEmitter<string> = new EventEmitter<string>();

  displayedColumns = ['codiGrup', 'descripcio', 'inici', 'fi', 'actiu'];

  constructor(
    private grupsService: SeguretatGrupsService,
    private filterService: FilterService,
    private dialog: MatDialog,
    private i18n: I18n
  ) {
  }

  ngOnInit() {

    this.sort.disableClear = true;
    this.dataSource = CustomDataSource.create<SeguretatGrups, SeguretatGrupsFilter>(this.paginator, new SeguretatGrupsFilterService(), 'urlGetSeguretatGrups', 'urlGetSeguretatGrupsCount');
    this.dataSource.subject.subscribe((data) => {
      data.forEach(item => {
        this.displayedItems[item.secureId] = {
          id: item.secureId
        };
      });
    });

    this.filter.filterUpdated.subscribe(updated => {
      if (updated) {
        this.load();
        if (!this.selectButton) { this.filterService.saveFilter('seguretat-grups-filter', this.filter); }
      }
    });

    if (!this.selectButton) { this.filterService.loadFilter('seguretat-grups-filter', this.filter); }
    this.filter.paginator.init(this.sort, this.paginator);
  }

  ngAfterViewInit() {
    // reset the paginator after sorting
    this.sort.sortChange.subscribe(() => {
      this.paginator.pageIndex = 0;
      this.filter.paginator.set(this.sort, this.paginator);
      this.filter.updated();
    });

    merge(this.sort.sortChange, this.paginator.page)
    .pipe(tap(() => this.filter.updated()))
    .subscribe();

    this.load();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.updatedFilterData != null) {
      this.update();
    }
  }

  update() {
    if (this.dataSource !== undefined) {
      this.updatedFilterData.paginator.set(this.sort, this.paginator);
      this.dataSource.loadFilter(this.updatedFilterData);
    }
  }

  load() {
    this.filter.paginator.set(this.sort, this.paginator);
    this.dataSource.loadFilter(this.filter);
  }

  onRowClicked(row) {
    this.itemClicked.emit(row.secureId);
  }

  generateExcel(): void {
    let filter = this.filter;
    if (this.updatedFilterData != null) {
      filter = this.updatedFilterData;
    }
    this.dialog.open(DownloadExcelDialogComponent, {
        closeOnNavigation: false,
        autoFocus: true,
        data: Builder.newDownloadExcelDialogData(this.grupsService, filter, this.i18n('SeguretatGrups'), this.sort.direction, this.sort.active)
    });
  }

}
